export const characters = [
  {
    id: "lin-hui",
    name: "林慧",
    actor: "苏雅宁",
    roleType: "lead",
    tagline: "在母亲与自我之间寻找平衡的年轻女性",
    intro:
      "全剧核心人物，一位三十出头的年轻母亲。她温柔却并不软弱，在家庭与自我实现的拉扯中不断成长。从一个习惯性退让的妻子，一步步学会为自己争取。",
    background:
      "林慧出身于普通工薪家庭，大学时学的是设计，婚后为了照顾家庭搁置了职业理想。搬入老城区后，她一边应对婆媳相处的细碎摩擦，一边重新拾起被搁置多年的设计稿。她最大的矛盾在于：既想做孩子眼中随时在场的母亲，又不愿把自己活成只剩身份没有名字的人。全剧通过她的视角，展开对“年轻母亲”这一群体的细致观察。",
    relations: [
      { name: "陈志远", desc: "丈夫，两人从分歧走向并肩" },
      { name: "周晓彤", desc: "女儿，是她柔软也最坚硬的理由" },
      { name: "王秀兰", desc: "婆婆，从针锋相对到雨夜和解" },
      { name: "李静", desc: "闺蜜，把她重新拉回职场" },
    ],
    avatar:
      "https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20a%20calm%20young%20chinese%20mother%20in%20her%20early%20thirties%20wearing%20soft%20knitwear%2C%20gentle%20determined%20expression%2C%20muted%20warm%20neutral%20background%2C%20soft%20studio%20light%2C%20film%20grain&width=600&height=700&seq=ym2-ch-linhui&orientation=portrait",
  },
  {
    id: "chen-zhiyuan",
    name: "陈志远",
    actor: "陆承轩",
    roleType: "lead",
    tagline: "用逞强掩饰脆弱的丈夫与父亲",
    intro:
      "林慧的丈夫，一名责任心很强却不善表达的工程师。他把压力都咽进肚里，用沉默和逞强维系一个家的体面，直到父亲的变故让他第一次卸下盔甲。",
    background:
      "陈志远从小在父亲严厉的期待中长大，习惯用成绩和担当证明自己。他不擅长说软话，也难以察觉妻子细微的情绪波动。搬家、房贷、工作调动，这些现实的重量压在他肩上，让他一度把家庭当成必须完成的任务。直到父亲病危、妻子濒临崩溃，他才真正理解“并肩”的含义。他的成长线是全剧最克制也最打动人的一条。",
    relations: [
      { name: "林慧", desc: "妻子，重新学会沟通与道歉" },
      { name: "赵建国", desc: "父亲，和解在病房的深夜" },
      { name: "王秀兰", desc: "母亲，血脉里的沉默与传承" },
      { name: "陈小雨", desc: "妹妹，长兄如父的牵挂" },
    ],
    avatar:
      "https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20a%20serious%20chinese%20man%20in%20his%20mid%20thirties%20wearing%20simple%20shirt%2C%20restrained%20gentle%20expression%2C%20muted%20cool%20neutral%20background%2C%20soft%20studio%20light%2C%20film%20grain&width=600&height=700&seq=ym2-ch-zhiyuan&orientation=portrait",
  },
  {
    id: "wang-xiulan",
    name: "王秀兰",
    actor: "郑佩云",
    roleType: "lead",
    tagline: "刀子嘴豆腐心，藏着半生辛酸的婆婆",
    intro:
      "陈志远的母亲，一位传统而坚韧的老人。她嘴上挑剔、事事要强，把关心藏在指责里。随着剧情推进，她隐忍多年的健康问题与往事被揭开，人物形象逐渐立体。",
    background:
      "王秀兰年轻时独自拉扯一双儿女，靠一双巧手把家撑了起来。丈夫赵建国沉默寡言，两人之间那句没说出口的话，成了她半生的结。她对儿媳的挑剔，其实是害怕自己被这个家“用不上”。雨夜那场长谈，让她第一次把积压的委屈说出来。她不是反派，而是被时代与婚姻塑造成的样子。",
    relations: [
      { name: "林慧", desc: "儿媳，从对立到彼此托付" },
      { name: "赵建国", desc: "丈夫，半生未说完的话" },
      { name: "陈志远", desc: "儿子，最深的牵挂" },
      { name: "周晓彤", desc: "孙女，晚年最大的柔软" },
    ],
    avatar:
      "https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20an%20elderly%20dignified%20chinese%20woman%20with%20grey%20hair%20pulled%20back%2C%20stern%20but%20warm%20expression%2C%20muted%20warm%20grey%20background%2C%20soft%20studio%20light%2C%20film%20grain&width=600&height=700&seq=ym2-ch-xiulan&orientation=portrait",
  },
  {
    id: "zhou-xiaotong",
    name: "周晓彤",
    actor: "何以然",
    roleType: "lead",
    tagline: "懂事又倔强的小女孩，家庭情绪的晴雨表",
    intro:
      "林慧的女儿，一个七岁的小女孩。她敏感、懂事，用孩子的眼光观察大人的世界。全剧里她那些看似天真的举动，往往戳中家庭关系最真实的角落。",
    background:
      "晓彤在父母的忙碌中长大，早早学会了自己系鞋带、自己热牛奶。她会在争吵后画一家人的画，也会在生日被放鸽子后安静地不说话。她的懂事让人心疼，也让林慧不断反思：一个孩子不该过早地学会体谅。她与奶奶之间跨越年龄的亲近，是全剧最暖的支线。",
    relations: [
      { name: "林慧", desc: "妈妈，最依赖也最理解她的人" },
      { name: "陈志远", desc: "爸爸，偏爱却不知如何表达" },
      { name: "王秀兰", desc: "奶奶，最亲密的玩伴" },
      { name: "李静", desc: "干妈，带来外面世界的惊喜" },
    ],
    avatar:
      "https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20a%20cute%20thoughtful%20young%20chinese%20girl%20about%20seven%20years%20old%20with%20short%20hair%2C%20bright%20curious%20eyes%2C%20soft%20warm%20neutral%20background%2C%20gentle%20studio%20light%2C%20film%20grain&width=600&height=700&seq=ym2-ch-xiaotong&orientation=portrait",
  },
  {
    id: "li-jing",
    name: "李静",
    actor: "白露",
    roleType: "lead",
    tagline: "光鲜独立的闺蜜，也是最清醒的旁观者",
    intro:
      "林慧大学时代的挚友，如今是一名事业有成的自由职业者。她活成了林慧羡慕的样子，却也在光鲜背后藏着自己的孤独。她既是林慧重返职场的引路人，也是全剧的“清醒剂”。",
    background:
      "李静选择了一条截然不同的路：不婚、不将就、把事业握在自己手里。她看似洒脱，其实也在深夜的公寓里感到空荡。她看穿了林慧的犹豫，鼓励她“先把自己活明白”。但她并不完美，她的强势有时也会伤人。这一角色的存在，让剧集对“女性选择”的讨论多了一个不折中立的参照系。",
    relations: [
      { name: "林慧", desc: "挚友，见证彼此的成长" },
      { name: "孙婉", desc: "旧识，观点针锋相对" },
      { name: "周晓彤", desc: "干女儿，她最柔软的一面" },
      { name: "高铭", desc: "意外的交集，埋下伏笔" },
    ],
    avatar:
      "https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20a%20confident%20stylish%20chinese%20woman%20with%20elegant%20short%20hair%2C%20cool%20assured%20expression%2C%20muted%20modern%20neutral%20background%2C%20soft%20studio%20light%2C%20film%20grain&width=600&height=700&seq=ym2-ch-lijing&orientation=portrait",
  },
  {
    id: "sun-wan",
    name: "孙婉",
    actor: "顾清瑶",
    roleType: "support",
    tagline: "职场上的对手，也是另一个罗生门里的自己",
    intro:
      "林慧的职场对手，能力出众、八面玲珑。她与林慧围绕同一项目明争暗斗，却在一次深夜加班后展露了自己同样沉重的家庭负担。",
    background:
      "孙婉独自赡养着一位身患慢性病的母亲，光鲜的职场形象是她用无数个通宵换来的。她对林慧的强势，一半是竞争，一半是羡慕——羡慕她还有可以依靠的家。两人从对手到盟友的转变，是全剧职场线最耐看的部分。她证明了“女性之间也可以既竞争又成全”。",
    relations: [
      { name: "林慧", desc: "从对手到盟友" },
      { name: "李静", desc: "旧识，价值观碰撞" },
    ],
    avatar:
      "https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20a%20sharp%20capable%20chinese%20office%20woman%20in%20tailored%20blazer%2C%20composed%20ambitious%20expression%2C%20muted%20cool%20neutral%20background%2C%20soft%20studio%20light%2C%20film%20grain&width=600&height=700&seq=ym2-ch-sunwan&orientation=portrait",
  },
  {
    id: "zhao-jianguo",
    name: "赵建国",
    actor: "秦世忠",
    roleType: "support",
    tagline: "沉默的父亲，带着一段未完成的人生",
    intro:
      "陈志远的父亲，一位沉默寡言的老工人。他一生要强，与儿子之间隔着说不出口的话。一场重病，让尘封多年的往事浮出水面。",
    background:
      "赵建国在工厂里干了半辈子，习惯了用行动代替语言。他与王秀兰的婚姻平静得像一潭水，底下却压着年轻时的另一段故事。相册里的那张旧照片，是他一生中最深的秘密。病床前，他终于把没说完的话说给了儿子。他的存在，让这个家庭剧从日常里长出了厚度。",
    relations: [
      { name: "王秀兰", desc: "妻子，半生沉默的相守" },
      { name: "陈志远", desc: "儿子，迟来的理解" },
      { name: "林慧", desc: "儿媳，陌生的亲近" },
    ],
    avatar:
      "https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20a%20silent%20old%20chinese%20man%20with%20deep%20wrinkles%20and%20grey%20hair%2C%20stoic%20weathered%20expression%2C%20muted%20grey%20neutral%20background%2C%20soft%20studio%20light%2C%20film%20grain&width=600&height=700&seq=ym2-ch-jianguo&orientation=portrait",
  },
  {
    id: "chen-xiaoyu",
    name: "陈小雨",
    actor: "方宁",
    roleType: "support",
    tagline: "夹在旧家庭与新生活之间的年轻一代",
    intro:
      "陈志远的妹妹，性格直率外向。她带着交往对象回家，却在一顿团圆饭里看清了自己对婚姻的犹豫，也成了连接两代人的桥梁。",
    background:
      "小雨比哥哥小八岁，是被全家宠着长大的。她看不惯家里的旧规矩，却又不忍心彻底离开。她与嫂子的关系更像是朋友，会在深夜下楼散步时把心事一股脑说出来。她的婚事线，折射出年轻一代面对婚姻时的迟疑与清醒。",
    relations: [
      { name: "陈志远", desc: "哥哥，从小依赖的对象" },
      { name: "林慧", desc: "嫂子，最好的倾诉对象" },
      { name: "王秀兰", desc: "母亲，爱与挣脱" },
    ],
    avatar:
      "https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20a%20lively%20young%20chinese%20woman%20in%20her%20late%20twenties%20with%20casual%20style%2C%20bright%20candid%20smile%2C%20muted%20warm%20neutral%20background%2C%20soft%20studio%20light%2C%20film%20grain&width=600&height=700&seq=ym2-ch-xiaoyu&orientation=portrait",
  },
  {
    id: "gao-ming",
    name: "高铭",
    actor: "温子健",
    roleType: "support",
    tagline: "耐心克制的主治医生，风浪里的定心丸",
    intro:
      "儿科主治医生，在晓彤体检出现异常时给予林慧专业的解释与安心的力量。他温和理性，是剧中最让人信任的角色之一。",
    background:
      "高铭在医院里以耐心著称，他习惯用最平实的语言把复杂的情况讲清楚。他与林慧的几次交流，总是在对方最慌乱的时刻出现。他不介入别人的家庭，只在专业边界内给予支撑。这个角色让剧集在情感之外，多了一份现实的可靠感。",
    relations: [
      { name: "林慧", desc: "患者家属，信任与被信任" },
      { name: "周晓彤", desc: "小患者，被照顾的对象" },
      { name: "李静", desc: "意外的交集" },
    ],
    avatar:
      "https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20a%20calm%20chinese%20male%20doctor%20in%20white%20coat%20with%20glasses%2C%20kind%20patient%20expression%2C%20clean%20soft%20neutral%20background%2C%20soft%20studio%20light%2C%20film%20grain&width=600&height=700&seq=ym2-ch-gaoming&orientation=portrait",
  },
  {
    id: "fang-laoshi",
    name: "方老师",
    actor: "许晴岚",
    roleType: "support",
    tagline: "幼儿园里温柔而坚定的引路人",
    intro:
      "晓彤的幼儿园老师，一个细心温和的教育工作者。她在孩子冲突与家庭分歧中，始终站在专业与理解的一侧。",
    background:
      "方老师从业十余年，见过各种家庭。她不会轻易评判任何一位家长，而是用观察和建议帮助他们看见孩子真正的需要。她在第二集把林慧叫到幼儿园，那次谈话成了夫妻分歧爆发的导火索，也成了后续和解的起点。她是全剧最安静却不可缺少的支点。",
    relations: [
      { name: "周晓彤", desc: "学生，细致的观察者" },
      { name: "林慧", desc: "家长，专业而克制的沟通" },
    ],
    avatar:
      "https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20a%20gentle%20chinese%20kindergarten%20teacher%20woman%20with%20soft%20hair%20bun%2C%20warm%20patient%20smile%2C%20muted%20warm%20neutral%20background%2C%20soft%20studio%20light%2C%20film%20grain&width=600&height=700&seq=ym2-ch-fanglaoshi&orientation=portrait",
  },
];